/* Maison Blonde: swatch preview on touch devices (Oct 31, 2026).
   Tap a furniture fabric/wood swatch -> it selects as normal AND a half-width preview opens above it.
   Closes on the X, a tap outside, or scrolling. Desktop keeps the CSS hover preview. */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: none)').matches) return;
  var panel, openLabel = null, startY = 0;

  function build() {
    panel = document.createElement('div');
    panel.className = 'mb-swatch-pop';
    panel.setAttribute('role', 'dialog');
    panel.innerHTML = '<div class="mb-swatch-pop__media"></div><span class="mb-swatch-pop__label"></span>' +
      '<button type="button" class="mb-swatch-pop__close" aria-label="Close">&times;</button>';
    panel.querySelector('button').addEventListener('click', function (e) { e.stopPropagation(); close(); });
    document.body.appendChild(panel);
  }

  function labelOf(sw) {
    var l = sw.querySelector('.swatch-preview__label');
    return l ? l.textContent.trim() : '';
  }

  function place(sw) {
    var r = sw.getBoundingClientRect(), w = panel.offsetWidth, h = panel.offsetHeight;
    var left = Math.max(8, Math.min(r.left + r.width / 2 - w / 2, window.innerWidth - w - 8));
    var top = r.top - h - 10;
    if (top < 8) top = r.bottom + 10;
    panel.style.left = (left + window.scrollX) + 'px';
    panel.style.top = (top + window.scrollY) + 'px';
  }

  function open(sw) {
    var src = sw.querySelector('.swatch-preview');
    if (!src) return;
    if (!panel) build();
    var media = panel.firstElementChild;
    media.innerHTML = '';
    var img = src.querySelector('img');
    if (img) {
      var i = new Image();
      i.src = img.getAttribute('src');
      i.alt = '';
      i.width = 240; i.height = 240;
      media.appendChild(i);
    } else {
      var c = src.querySelector('.swatch-preview__color'), d = document.createElement('span');
      d.className = 'mb-swatch-pop__color';
      if (c) d.style.background = c.style.background;
      media.appendChild(d);
    }
    openLabel = labelOf(sw);
    panel.querySelector('.mb-swatch-pop__label').textContent = openLabel;
    panel.classList.add('is-open');
    place(sw);
    startY = window.scrollY;
    // The theme redraws the picker after a selection; re-anchor to the redrawn swatch.
    setTimeout(function () {
      if (!openLabel) return;
      var all = document.querySelectorAll('.color-swatch.has-preview');
      for (var k = 0; k < all.length; k++) if (labelOf(all[k]) === openLabel) { place(all[k]); break; }
    }, 450);
  }

  function close() {
    if (panel) panel.classList.remove('is-open');
    openLabel = null;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var sw = t.closest && t.closest('.color-swatch.has-preview');
    if (sw) { open(sw); return; }
    // the label click also fires on its hidden radio input; ignore that one
    if (t.matches && t.matches('input') && t.nextElementSibling && t.nextElementSibling.classList.contains('has-preview')) return;
    if (panel && openLabel && !panel.contains(t)) close();
  });

  window.addEventListener('scroll', function () {
    if (openLabel && Math.abs(window.scrollY - startY) > 40) close();
  }, { passive: true });
})();
